import React from 'react';

// Components
import { Download } from '../../_lib/components/Download';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import ILink from '../../types/ILink';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type EventIcalDownloadProps = {
  icalLink?: ILink;
};

/**
 * Component to download an iCalender File (*.ics).
 */
export function EventIcalDownload({ icalLink }: EventIcalDownloadProps) {
  const { t } = useSonTranslation('EventIcalDownload');

  const { editModeInfo } = useAppContext();

  // we're hiding iCal download in edit mode
  if (editModeInfo.active || !icalLink) {
    return null;
  }

  return (
    <div className="event-ical-download">
      <h2 className="invisible">{t('ical')}</h2>
      <Download
        url={icalLink.url}
        fileExtension="ics"
        mimeType="text/calendar"
        fileSizeBytes={4096}
        fileName={t('ical')}
      />
    </div>
  );
}

export const EventIcalDownloadBlock = asBlock<
  EventIcalDownloadProps,
  BlockType.eventicaldownload
>(EventIcalDownload);
